export const CUSTOM_REFERENCE_CHECK_TYPE = 'custom_reference';

export function shouldHideCustomReferenceAiSummary({ checkType, brand = {}, companyChecks = [] }) {
  if (checkType !== CUSTOM_REFERENCE_CHECK_TYPE) {
    return true;
  }

  const companyCheck = companyChecks.find(cc => cc.type === CUSTOM_REFERENCE_CHECK_TYPE);

  return (
    brand?.ff_ai_reference_summary !== true || companyCheck?.configuration?.ai_summary !== true
  );
}
